module.exports = __webpack_public_path__ + "img/collection-engagementRingsEntwined@2x.59ead1c.webp";